import React, { useState, useEffect } from 'react';
import * as Yup from 'yup';
import {
  CrudMasterDetailView,
  CrudContext,
  GridView,
  MasterDetailForm,
  Widget,
  FormatText,
  FormNumber,
  FormInput,
  FormDatePicker,
  FormSubmitButton,
  Button,
  CompositeView,
} from '@digital/ui';

import { CrfOrcamentoPlanilha } from '@app/api/crf/crfOrcado';

import UploadFile from '@app/components/uploadFile';
import { hasPermission } from '@app/helpers/permissions';

import { createPlanilhaCapex, GetAllCrfPlanilhaCapexAntigas, getAllCrfProjetosPlanilhaCapexModulo } from '@app/api/crf/crfProjeto';

import CrfPlanilhaCapexTabela from './CrfPlanilhaCapexTabela';
import CrfTablePlanilha from '../CrfTablePlanilhas';
import { exportaCrfModelo, exportaCrfPlanilhaCapexAntiga } from '@app/api/crf/crfExportaFile';
import { EExportarModeloCrf } from '@app/enums/EExportarModeloCrf';

const CrfPlanilhaCapexComponent = () => {
  const [projetos, setProjetos] = useState(() => getAllCrfProjetosPlanilhaCapexModulo);
  const [hasFile, setHasFile] = useState(false);
  const [atualizarTela, setAtualizarTela] = useState<boolean>(false);
  const [planilhas, setPlanilhas] = useState<CrfOrcamentoPlanilha[]>();
  const [projetoSelecionado, setProjetoSelectionado] = useState<CrfOrcamentoPlanilha>();

  const handleCreatePlanilhaOrcamento = (values: any, selectedItem: any) => {
    createPlanilhaCapex(selectedItem.id, values.formData, values).then((result: any) => {
      if (result && result.valid) {
        setHasFile(true);
        setHasFile(false);
        setAtualizarTela(!atualizarTela);
        setProjetos(() => Promise.resolve(undefined));
        setProjetos(() => getAllCrfProjetosPlanilhaCapexModulo);
      }
    });
  };

  useEffect(() => {
    const getPlanilhasData = async (id: string) => {
      const result = await GetAllCrfPlanilhaCapexAntigas(id);
      if (result && Array.isArray(result)) setPlanilhas(result);
    };

    if (projetoSelecionado) getPlanilhasData(projetoSelecionado.id);
  }, [projetoSelecionado]);

  const exportarPlanilha = (item: CrfOrcamentoPlanilha) => {
    if (item) {
      exportaCrfPlanilhaCapexAntiga(item.projetoId, item.nome, item.numero, item.revisao, item.dataAprovacao);
    }
  };

  const validationSchema = Yup.object().shape({
    dataAprovacao: Yup.date().required('Data de Aprovação é obrigatória.'),
  });

  return (
    <CrudMasterDetailView
      getAllItems={projetos}
      disableNotification
      icon="business-estimate"
      detailTitleExtractor={x => `PLANILHA ORÇADO PLURIANUAL DO PROJETO ${x.codigo}`}
      filterPredicate={(item, value) =>
        item.nome.toLowerCase().includes(value.toLowerCase()) ||
        (item.codigo && item.codigo.toLowerCase().includes(value.toLowerCase())) ||
        (item.statusNome && item.statusNome.toLowerCase().includes(value.toLowerCase())) ||
        item.numero.toLowerCase().includes(value.toLowerCase())
      }
      titleExtractor={item => `${item.codigo} - ${item.nome}`}
      descriptionExtractor={item => item.statusNome || ''}>
      <CompositeView>
        {hasPermission(['Dono', 'ORCADO_ECONOMICO_CAPEX_VISUALIZAR_MENU']) && (
          <CrudContext.Consumer>
            {({ selectedItem }) => {
              setProjetoSelectionado(selectedItem);
              return (
                <GridView noform>
                  {hasPermission(['ORCADO_ECONOMICO_CAPEX_EDITAR_ABA_INDEX']) && (
                    <MasterDetailForm
                      validationSchema={validationSchema}
                      onSubmit={values => {
                        handleCreatePlanilhaOrcamento(values, selectedItem);
                      }}>
                      <Widget
                        title="Importação de planilha"
                        actions={[
                          selectedItem && selectedItem.possuiPlanilhaCapex === true && <> </>,
                          <Button
                            type="link"
                            icon="files-xls"
                            onClick={() => {
                              exportaCrfModelo(EExportarModeloCrf.MODELO_IMPORTACAO_CAPEX);
                            }}>
                            Modelo de importação
                          </Button>,
                          hasPermission(['ORCADO_ECONOMICO_CAPEX_EDITAR_ABA_INDEX']) && (
                            <FormSubmitButton type="primary">
                              <FormatText id="ui.commons.save" uppercase />
                            </FormSubmitButton>
                          ),

                        ]}>
                        <FormNumber label="Número" name="numero_planilha" span={4} />
                        <FormInput label="Revisão" name="texto_revisao" span={4} />
                        <FormDatePicker
                          label="Data de Aprovação"
                          name="dataAprovacao"
                          format="DD/MM/YYYY"
                          span={4}
                          required
                        />
                        {selectedItem && hasPermission(['ORCADO_ECONOMICO_CAPEX_EDITAR_ABA_INDEX']) ? (
                          <UploadFile
                            hasFile={hasFile}
                            accept=".xlsx"
                            label="Incluir planilha"
                            id="importFilePlanilha"
                            selectedItem={selectedItem}
                          />
                        ) : (
                          <> </>
                        )}
                      </Widget>
                    </MasterDetailForm>
                  )}
                  {selectedItem && hasPermission(['ORCADO_ECONOMICO_CAPEX_VISUALIZAR_MENU']) ? (
                    <CrfPlanilhaCapexTabela atualizarTelaProp={atualizarTela} projeto={selectedItem} />
                  ) : (
                    <> </>
                  )}
                  {selectedItem &&
                    hasPermission(['ORCADO_ECONOMICO_CAPEX_VISUALIZAR_MENU']) &&
                    (planilhas && planilhas.length > 0) ? (
                    <CrfTablePlanilha dataPlanilhas={planilhas || []} handleClick={exportarPlanilha} />
                  ) : (
                    <> </>
                  )}
                </GridView>
              );
            }}
          </CrudContext.Consumer>
        )}
      </CompositeView>
    </CrudMasterDetailView>
  );
};

export default CrfPlanilhaCapexComponent;
